// extracted by mini-css-extract-plugin
module.exports = {"gameLayout":"GameLayout_gameLayout__1hfBf"};